import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { Notifications, Survay } from '../models';

export class AccountSettingsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public survays: Survay[];
  public notifications: Notifications[];

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.survays = [];
    this.notifications = [];
  }
}
